import {createActions} from 'reduxsauce';

export const {Types: MentionLegalesTypes, Creators: MentionLegalesActionCreators} = createActions ({
    mentionLegalesStart: ["gridId"],
    mentionLegalesSuccess: ['data'],
    mentionLegalesFailure: ['error'],
    recommendedProductsStart: [null],
});